import { joinShortcodes, CompactEmoji } from 'emojibase';
import emojisEn from 'emojibase-data/en/compact.json';
import emojisRu from 'emojibase-data/ru/compact.json';
import shortcodes from 'emojibase-data/en/shortcodes/emojibase.json';

export const EMOJIS_EXCLUDE: { [hc: string]: boolean } = {
    '1f441-fe0f-200d-1f5e8-fe0f': true,
    '00a9': true,
    '00ae': true,
    '0023-fe0f-20e3': true,
    '002a-fe0f-20e3': true,
    '0030-fe0f-20e3': true,
    '0031-fe0f-20e3': true,
    '0032-fe0f-20e3': true,
    '0033-fe0f-20e3': true,
    '0034-fe0f-20e3': true,
    '0035-fe0f-20e3': true,
    '0036-fe0f-20e3': true,
    '0037-fe0f-20e3': true,
    '0038-fe0f-20e3': true,
    '0039-fe0f-20e3': true,
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': true,
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': true,
    '1f468-200d-2764-fe0f-200d-1f468': true,
    '1f469-200d-2764-fe0f-200d-1f469': true,
    '1f468-200d-1f468-200d-1f466': true,
    '1f468-200d-1f468-200d-1f467': true,
    '1f468-200d-1f468-200d-1f467-200d-1f466': true,
    '1f468-200d-1f468-200d-1f466-200d-1f466': true,
    '1f468-200d-1f468-200d-1f467-200d-1f467': true,
    '1f469-200d-1f469-200d-1f466': true,
    '1f469-200d-1f469-200d-1f467': true,
    '1f469-200d-1f469-200d-1f467-200d-1f466': true,
    '1f469-200d-1f469-200d-1f466-200d-1f466': true,
    '1f469-200d-1f469-200d-1f467-200d-1f467': true,
    '26a7': true,
    '1f3f3-fe0f-200d-26a7-fe0f': true,
    '1fac4': true,
    '1fac3': true
}

const EMOJIS: CompactEmoji[] = joinShortcodes(emojisRu, [shortcodes]).filter(e => e.shortcodes?.length && !EMOJIS_EXCLUDE[e.hexcode.toLowerCase()]);
export const EMOJIS_MAP: { [shortcode: string]: CompactEmoji } = {};
export const EMOJIS_HEXMAP: { [hexcode: string]: CompactEmoji } = {};
export const EMOJI_EMOTICONS: { [emoticon: string]: string } = {};
export const EMOJI_GROUPS: string[][] = [];
export const EMOJI_SEARCH: { [hexcode: string]: string } = {};
export const EMOJI_HEXCODES: string[] = [];

// const emoticonsForRegex: string[] = [];
EMOJIS.forEach(e => {
    EMOJIS_HEXMAP[e.hexcode] = e;
    EMOJI_HEXCODES.push(e.hexcode);
    if (e.group != null) {
        if (!EMOJI_GROUPS[e.group]) {
            EMOJI_GROUPS[e.group] = [];
        }
        EMOJI_GROUPS[e.group].push(e.hexcode);
        EMOJI_SEARCH[e.hexcode] = e.label.toLocaleLowerCase();
        if (e.tags?.length) {
            EMOJI_SEARCH[e.hexcode] += '⍰' + e.tags.join('⍰').toLocaleLowerCase();
        }
        if (e.shortcodes?.length) {
            EMOJI_SEARCH[e.hexcode] += '⍰' + e.shortcodes.join('⍰');
        }
    }
    e.shortcodes!.forEach(code => EMOJIS_MAP[code] = e);
    if (e.emoticon && typeof e.emoticon == 'string') {
        // emoticonsForRegex.push(escapeRegExp(e.emoticon));
        EMOJI_EMOTICONS[e.emoticon] = e.hexcode;
    }
});
emojisEn.filter(e => e.shortcodes?.length && !EMOJIS_EXCLUDE[e.hexcode.toLowerCase()]).forEach(e => {
    if (EMOJIS_HEXMAP[e.hexcode]) {
        if (!EMOJIS_HEXMAP[e.hexcode].tags) {
            EMOJIS_HEXMAP[e.hexcode].tags = [];
        }
        if (e.tags?.length) {
            e.tags.forEach(tag => {
                if (!EMOJIS_HEXMAP[e.hexcode].tags!.includes(tag)) {
                    EMOJIS_HEXMAP[e.hexcode].tags!.push(tag);
                }
            });
        }
    }
});

// export const EMOTICON_REGEX = new RegExp(`(?:^|\\s)(${emoticonsForRegex.join('|')})\\s$`);
export const EMOTICON_REGEX = /:([a-zA-Z0-9_+-]+):$/; // new RegExp(`(?:^|\\s):([a-zA-Z\\+_\\-]):\\s$`);

// function escapeRegExp(s: string): string {
//     const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
//     const reHasRegExpChar = RegExp(reRegExpChar.source);
//       return (s && reHasRegExpChar.test(s)) ? s.replace(reRegExpChar, '\\$&') : (s || '');
// }
